<div class="adjust-securities-rebalance-settings">
  <div class="flex-row">
    <div class="flex-column flex-column-header">
      <strong>Equivalents</strong>
    </div>
    <div class="flex-column">
      <div class="flex-vertical-center">
        <p-checkbox name="includeEquivalentAndAltSecurities"
          [(ngModel)]="analysisPackage.adjustSecDto.includeEquivalentAndAltSecurities" binary="true"
          disabled="disabled"
          inputId="adjustsecitem1">
        </p-checkbox>
        <label style="padding-right:3px;padding-left: .2rem;" for="adjustsecitem1">Include Equivalent and Alt Securities</label>
        <span class="tooltipIcon infoIcon" calltoaction
        [calltoactionTemplate]="equivalentToolTipIcon"></span>
      </div></div>
    </div>
    <div class="flex-row">
      <div class="flex-column flex-column-header">
        <span><strong>Allow in:</strong></span>
        <span class="tooltipIcon infoIcon" calltoaction
        [calltoactionTemplate]="adjustSettingsToolTipIcon"></span></div>
        <div class="flex-column">
          <div class="checkboxes-horizontal-align">
            <div class="flex-checkbox-item">
              <p-checkbox name="isTaxable" [(ngModel)]="analysisPackage.adjustSecDto.isTaxable"
                binary="true"
                (onChange)="onAllowInModified();" [disabled]="isReadOnly"
                inputId="adjustsecitem2">
              </p-checkbox>
              <label for="adjustsecitem2" style="padding-left: .2rem;">Taxable accounts</label>
            </div>
            <div class="flex-checkbox-item">
              <p-checkbox name="isQualified"
                [(ngModel)]="analysisPackage.adjustSecDto.isQualified"
                binary="true" (onChange)="onAllowInModified();" [disabled]="isReadOnly"
                inputId="adjustsecitem3">
              </p-checkbox>
              <label for="adjustsecitem3" style="padding-left: .2rem;">Qualified accounts</label>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column flex-column-header">
          <strong>Buy using cash above: </strong>
        </div>
        <div class="flex-column">
          <div class="checkboxes-horizontal-align">
            <div class="flex-radio-item">
              <p-radioButton name="cashGroup" value="CASH_TARGET" (ngModelChange)="onCashChange($event)"
                [(ngModel)]="buyUsing" [disabled]="isReadOnly"
              inputId="adjustsecitem4"></p-radioButton>
              <label style="padding-right:3px;" for="adjustsecitem4">Cash target</label>
              <span class="tooltipIcon infoIcon" calltoaction [calltoactionTemplate]="cashTargetToolTipIcon"
              style="padding-left: 15px;"></span>
            </div>
            <div class="flex-radio-item">
              <p-radioButton name="cashGroup" value="CASH_MIN" (ngModelChange)="onCashChange($event)"
                [(ngModel)]="buyUsing" [disabled]="isReadOnly"
              inputId="adjustsecitem5"></p-radioButton>
              <label style="padding-right:3px;" for="adjustsecitem5">Cash minimum</label>
              <span class="tooltipIcon infoIcon" calltoaction [calltoactionTemplate]="cashMinimumToolTipIcon"
              style="padding-left: 15px;"></span>
            </div>
            <div class="flex-radio-item">
              <p-radioButton name="cashGroup" inputId="adjustseccahmax" value="CASH_MAX" (ngModelChange)="onCashChange($event)"
              [(ngModel)]="buyUsing" [disabled]="isReadOnly"></p-radioButton>
              <label style="padding-right:3px;" for="adjustseccahmax">Cash maximum</label>
              <span class="tooltipIcon infoIcon" calltoaction [calltoactionTemplate]="cashMaximumToolTipIcon"
              style="padding-left: 15px;"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row zero-bottom-margin">
        <div class="flex-column flex-column-header flex-search-securities-header"><strong>Securities to be adjusted</strong></div>
        <div class="flex-column  fixed-width-column">
          <div class="flex-securities-search-container">
            <div class="search-add-container">
              <div class="search-symbol-header "> Search by symbol</div>
              <div>
                @if (!isReadOnly) {
                  <irb-dropdown-search-multiple #adjustSecDropDown [(values)]="adjustSecTargets"
                    [addNewItem]="addNewSecurityItem"
                    (openNewItemFlow)="openNewItemSecurityFlow($event)"
                    (search)="getAdjustSecurities($event)" [enableHiddenSearchResults]="true"
                    (selection)="onAdjustSecChange($event)"
                    style="width: 300px !important; vertical-align: middle;" size="30">
                  </irb-dropdown-search-multiple>
                }
                @if (isReadOnly) {
                  <select [disabled]='true' class="select-readonly">
                  </select>
                }
              </div>
              <div>
                <button (click)="addSecurities()" [disabled]="isReadOnly || !disableAddAdjustSec()"
                  class="btn-medium-secondary replace-securiries-btn-add btn-spacer">Add
                </button>
              </div>
              @if (toolTipShow) {
                <div class="tooltip">
                  <span id="tooltiptext" class="tooltiptext">
                    {{tooltipMessage}}
                  </span>
                </div>
              }
            </div>
            <div class="search-add-container">
              <div class="search-symbol-header "> Search by attributes</div>
              <div><button id="advancedFilterButton" (click)="showAddMultipleSecuritiesDialog()" [disabled]="isReadOnly"
                class="btn-medium-secondary replace-securiries-btn-add-multi"> Advanced Filter
              </button> &nbsp;</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row zero-bottom-margin">
        <div class="flex-column flex-column-header  flex-adjust-settings-header">
          <span><strong>Adjust settings</strong></span>
          <span class="tooltipIcon infoIcon" calltoaction
          [calltoactionTemplate]="adjustSettingsToolTipIcon"></span>
        </div>
        <div class="flex-column">
          <div class="flex-adjust-settings-container">
            <div class="adjust-settings-row-container">
              Specify values to apply to all securities listed below (optional)
            </div>
            <div class="adjust-settings-row-container">
              <div class="adjust-settings-column-container">
                <div class="adjust-settings-header">Order type</div>
                <div> <irb-dropdown-filter #IrbadjSecDropdown
                  id="irbSelectedRebalanceTypeDropdown"
                  [(value)]="orderType"
                  [size]="15"
                  (search)="setChainTypeOptions($event)"
                ></irb-dropdown-filter></div>
                <div><button (click)="updateOrderType()" [disabled]="isReadOnly || numSec === 0" class="btn-medium-secondary settings-button btn-spacer">
                  Apply
                </button> &nbsp;</div>
              </div>
              <div class="adjust-settings-column-container">
                <div class="adjust-settings-header">Target</div>
                <div> <irb-dropdown-filter #IrbadjTargetSecDropdown
                  [(value)]="target"
                  [size]="15"
                  (search)="setTargetChainTypeOptions($event)"
                ></irb-dropdown-filter>
              </div>
              @if (target.value == 'SPECIFY_PERC' || target.value == 'ADD_PREC' || target.value == 'REDUCE_PREC') {
                <div  class="adjust-settings-specify-percent-textbox-container">
                  @if (target.value == 'SPECIFY_PERC' || target.value == 'ADD_PREC' || target.value == 'REDUCE_PREC') {
                    <span>
                      @if (!isReadOnly) {
                        <irb-number-text-box [(value)]="percentOfPortfolio" places="2" min="0"
                          max="100"
                          [disabled]="isReadOnly"
                        width="50px"></irb-number-text-box>
                        } % of portfolio
                      </span>
                    }
                  </div>
                }
                <div>
                  <button (click)="updateTargetandPercent()" [disabled]="isReadOnly || numSec === 0"
                    class="btn-medium-secondary settings-button btn-spacer">Apply
                  </button> &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row zero-bottom-margin">
        <div class="flex-column flex-column-header"></div>
        <div class="flex-column"><strong>{{numSec}} securities to be adjusted</strong></div>
      </div>
      <div class="flex-row">
        <div class="flex-column flex-column-header"></div>
        <div class="flex-column fixed-width-column">
          @if (!isUiTest) {
            <div style="width: 730px;">
              <irb-inventory-grid
                [style.height]="'100%'"
                [style.width]="'100%'"
                [gridHeight]="'240px'"
                [showSideBar]="false"
                [gridOptions]="gridOptions"
                [frameworkComponents]='frameworkComponents'
                (gridReady)="onGridReady($event)"
              ></irb-inventory-grid>
            </div>
          }
        </div>
      </div>
    </div>
    <ng-template #adjustSettingsToolTipIcon>
      After selecting securities to adjust, you can use these inputs to quickly apply the adjust settings to all selections,
      so you don't have to enter the same settings for each security. You can edit the settings for any individual security
      after applying these same settings to all.
    </ng-template>

    <ng-template #cashTargetToolTipIcon>
      Only the cash exceeding an account's cash target will be used for the buy. (Set-aside cash is never used for this.)
    </ng-template>
    <ng-template #cashMinimumToolTipIcon>
      All the cash exceeding an account's minimum cash value will be used for the buy. (Set-aside cash is never used for
      this.)
    </ng-template>
    <ng-template #cashMaximumToolTipIcon>
      All the cash exceeding an account's maximum cash value will be used for the buy. (Set-aside cash is never used for this.)
    </ng-template>
    <ng-template #equivalentToolTipIcon>
      If this box is selected, equivalent and alternative securities will be included
      in the target percentage calculations – and may be sold or purchased in place of
      the targeted security to achieve the desired target allocation. Equivalents and alternatives
      will only be included in the calculations if they exist in the client's assigned model.
    </ng-template>
